<template>
  <div class="mt-4">
    <label for="name" class="text-field-label">Avatar</label>
    <div class="d-flex flex-row align-stretch mb-8 mt-4">
      <div>
        <user-avatar :avatar="avatar" size="120" tile />
      </div>

      <div class="d-flex flex-column justify-space-around ml-6">
        <v-btn
          text
          color="primary"
          class="text-capitalize"
          @click="showCropperModalAvatar = !showCropperModalAvatar"
          :loading="loading"
        >
          <v-icon left>{{icons.addImage}}</v-icon>Upload Image
        </v-btn>

        <v-btn
          v-if="avatar"
          text
          color="primary"
          class="text-capitalize"
          @click="deleteConfirmDialog = true"
          :loading="loading"
        >
          <v-icon left>{{icons.delete}}</v-icon>Delete Image
        </v-btn>
      </div>

      <image-cropper v-model="showCropperModalAvatar" @change="avatarChange" maxWidth="500" />
    </div>

    <v-dialog v-model="deleteConfirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Avatar</v-card-title>
        <v-card-text>
          <strong>Are you sure you want to delete?</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="deleteConfirmDialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteAvatar">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert
      v-if="avatarErrorMessage"
      text
      type="error"
      class="text-left pa-2"
    >{{ avatarErrorMessage.toString() }}</v-alert>
  </div>
</template>

<script>
import { mdiImagePlus, mdiDelete } from '@mdi/js'
import ImageCropper from '@/components/modals/ImageCropper'
import UserAvatar from '@/components/UserAvatar'

export default {
  props: {
    loading: {
      type: Boolean
    },
    avatar: {
      type: Object
    },
    avatarErrorMessage: {
      type: [String, Array]
    }
  },

  components: {
    UserAvatar,
    ImageCropper
  },

  data () {
    return {
      showCropperModalAvatar: false,
      deleteConfirmDialog: false,
      icons: {
        addImage: mdiImagePlus,
        delete: mdiDelete
      }
    }
  },

  methods: {
    avatarChange (image) {
      this.$emit('change', image)
    },

    deleteAvatar () {
      this.$emit('avatarRemove')
      this.deleteConfirmDialog = false
    }
  }
}
</script>
